module.exports = __webpack_public_path__ + "img/DIOGO.607931cb.jpeg";